import { v4 } from 'uuid';
import { IndexedDatabase } from './indexedDatabase';

export enum SuggestionField {
  Tenant = 'tenant',
  Owner = 'owner',
}

export interface SuggestionRecord {
  id: string;
  field: SuggestionField;
  values: string[];
}

export class SuggestionsDB extends IndexedDatabase<SuggestionRecord> {
  constructor(newData?: SuggestionRecord[]) {
    super('suggestions', ['field'], newData, { keyPath: 'field' });
  }

  async getFieldSuggestions(field: SuggestionField): Promise<string[]> {
    return await new Promise(resolve => {
      const request = this._openConnection();

      request.onsuccess = () => {
        if (this.database) {
          const objectStore = this.database.transaction([this.name], 'readonly').objectStore(this.name).index('field');
          const suggestionDbRecordRequest = objectStore.get(field);

          suggestionDbRecordRequest.onsuccess = () => {
            const suggestion = suggestionDbRecordRequest.result as SuggestionRecord | undefined;
            resolve(suggestion?.values ?? []);
          };
        }
      };
    });
  }

  async setFieldSuggestions(field: SuggestionField, suggestions: string[]): Promise<void> {
    return await new Promise(resolve => {
      const request = this._openConnection();

      request.onsuccess = () => {
        if (this.database) {
          const objectStore = this.database.transaction([this.name], 'readwrite').objectStore(this.name);
          const suggestionDbRecordRequest = objectStore.index('field').get(field);

          suggestionDbRecordRequest.onsuccess = () => {
            const data = suggestionDbRecordRequest.result as SuggestionRecord | undefined;

            if (data) {
              data.values = suggestions;
              const updateRequest = objectStore.put(data);

              updateRequest.onsuccess = () => {
                resolve();
              };
            } else {
              const newRecord = { field, values: suggestions, id: v4() };
              const createRequest = objectStore.add(newRecord);

              createRequest.onsuccess = () => {
                resolve();
              };
            }
          };
        }
      };
    });
  }
}
